import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const policiesApi = createApi({
    reducerPath: "policiesApi",
    tagTypes: ["Policies"],
    baseQuery,
    endpoints: (builder) => ({
        getPolicies: rtkClient.getPolicies(builder),
        getPolicyById: rtkClient.getPolicyById(builder),
        createPolicy: rtkClient.createPolicy(builder),
        updatePolicy: rtkClient.updatePolicy(builder),
        deletePolicy: rtkClient.deletePolicy(builder),
        assignPolicyToGroups: rtkClient.assignPolicyToGroups(builder),
        unassignPolicyFromGroups: rtkClient.unassignPolicyFromGroups(builder),
    }),
});

export const {
    useGetPoliciesQuery,
    useGetPolicyByIdQuery,
    useCreatePolicyMutation,
    useUpdatePolicyMutation,
    useDeletePolicyMutation,
    useAssignPolicyToGroupsMutation,
    useUnassignPolicyFromGroupsMutation,
} = policiesApi;
